const ToFixMessage = ({message}) => {
    return (
        <div className="text-neutral-400">
            (Fix memo: {message})
        </div>
    )
}

export default ToFixMessage;